// Theme Colors
// Initially this will be blank. Later on when app is initialized we will assign bootstrap colors to this from CSS variables.
export const $themeColors = {}

// App Breakpoints
// Initially this will be blank. Later on when app is initialized we will assign bootstrap breakpoints to this object from CSS variables.
export const $themeBreakpoints = { xs: 0, sm: 576, md: 768, lg: 992, xl: 1200 }

// APP CONFIG
export const $themeConfig = {
  app: {
    appName: 'Agendum', // Will update name in navigation menu (Branding)
    // eslint-disable-next-line global-require
    appLogoImage: require('@/assets/images/logo/logo.svg'), // Will update logo in navigation menu (Branding)
    appLogoPNGImage: require('@/assets/images/logo/logo-transparent.png'), // Will update logo in navigation menu (Branding)
    deepLinkScheme: process.env.VUE_APP_DEEP_LINK_SCHEME || 'agendum://', // Deep link scheme for mobile app
    androidPackageName: process.env.VUE_APP_ANDROID_PACKAGE_NAME || 'com.agendum', // Android package name for deep links
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'fade', // zoom-fade, slide-fade, fade-bottom, fade, zoom-out, none
    type: 'full', // full, vertical, horizontal
    contentWidth: 'boxed', // full, boxed
    menu: {
      hidden: false,
      isCollapsed: false,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: '', // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static', // static, sticky, hidden
    },
    customizer: true,
    enableScrollToTop: true,
    coverAspectRatio: '2.63',
  },
  cta: {
    active: 'default', // Set to null to disable, or 'christmas', 'default'
    christmas: {
      buttons: [
        {
          label: '🎅🎁 Secret Santa',
          searchQuery: 'secret santa',
          variant: 'outline-primary',
        },
        {
          label: '🍾🎉🎆 New Years\' Eve',
          searchQuery: 'New Year\'s Eve',
          variant: 'outline-primary',
        },
      ],
    },
    default: {
      buttons: [
        {
          label: `🍿 Let's see a movie`,
          searchQuery: 'movie',
          variant: 'outline-primary',
        },
        {
          label: '✈️ Plan a trip',
          searchQuery: 'traveling',
          variant: 'outline-primary',
        },
      ],
    },
    // Shown instead of the default CTA when the user is inside an organization context.
    // searchQuery values match ActivityTemplateType slugs seeded in the DB.
    organization: {
      buttons: [
        {
          label: '📅  Event',
          searchQuery: 'attending-an-event',
          variant: 'outline-primary',
        },
        {
          label: '💼 Work',
          searchQuery: 'meeting',
          variant: 'outline-primary',
        },
      ],
    },
  },
}
